import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import InputField from "./childComponents/inputComponents/InputField";
import SelectField from "./childComponents/inputComponents/SelectField";
import { FaBan } from "react-icons/fa";
import { MdContentPasteSearch, MdDelete } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";

const Pag = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Search WEBPAGE"; // Submit Button Name

  const [filteredRecords, setFilteredRecords] = useState([]);

  const [publishedRecords, setPublishedRecords] = useState(0);
  const [draftRecords, setDraftRecords] = useState(0);
  const [trashRecords, setTrashRecords] = useState(0);
  const [btnColor, setBtnColor] = useState("primary");

  const [displayMessages, setDisplayMessages] = useState("");
  const [searchType, setSearchType] = useState("");
  const [pageControl, setPageControl] = useState("parent");
  const [subMenuCounts, setSubMenuCounts] = useState({});
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedGrandChild, setSelectedGrandChild] = useState(null);

  const [allRecords, setAllRecords] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: null,
      endDate: null,
      item03: null,
      staff: null,
      status02: null,
    },
    button: {},
    select: {},
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchScript: null,
  });

  //replaces each first character of a word with its uppercase version
  function ucwords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const [options, setOptions] = useState({
    tableSize: [
      { values: "10", item: "10" },
      { values: "20", item: "20" },
      { values: "50", item: "50" },
      { values: "100", item: "100" },
    ],
  });

  useEffect(() => {
    (async () => await fetchPagData())();
  }, [
    pageControl,
    selectedParent,
    selectedChild,
    selectedGrandChild,
    dialogueState.editpost,
  ]);

  const searchDatabase = (event) => {
    event.preventDefault();
    const selectedType = event.currentTarget.dataset.value;

    setSearchType(selectedType); // still useful for UI display
    fetchPagData(selectedType); // pass value directly
  };

  const searchControlDatabase = (item01, item02, item02b) => {
    setSelectedParent(item01);
    setSelectedChild(item02);
    setSelectedGrandChild(item02b);

    // PARENT -> CHILD
    if (item02 == 0 && item02b == 0) {
      setPageControl("child");
    }

    // CHILD -> GRANDCHILD
    else if (item02 > 0 && item02b == 0) {
      setPageControl("grandchild");
    }

    // GRANDCHILD -> RESET TO PARENT
    else {
      setPageControl("parent");
    }
  };

  useEffect(() => {
    allRecords.forEach((record) => {
      const key = record.item01;
      const key2 = record.item02;
      const key3 = record.item02b;
      if (!subMenuCounts[key]) {
        getSubMenus(key, pageControl, key2, key3);
      }
    });
  }, [allRecords, pageControl]);

  const getSubMenus = async (item01, level, item02, item02b) => {
    const query =
      level === "parent"
        ? `?itemName[eq]=menue_tab&item01[eq]=${item01}&item02[ne]=0&item02b[eq]=0&status02[eq]=publish`
        : `?itemName[eq]=menue_tab&item01[eq]=${item01}&item02[eq]=${item02}&item02b[ne]=0&status02[eq]=publish`;

    try {
      await axios.get("sanctum/csrf-cookie");
      const res = await axios.get(`${BASE_URL}pagdata${query}`);
      if (res?.data?.status === 200) {
        setSubMenuCounts((prev) => ({
          ...prev,
          [item01]:
            res.data.allData.length > 0 ? res.data.allData.length : null,
        }));
      }
    } catch (error) {
      swal("Error", "Error fetching Submenus", "error");
      console.log("Submenu error:", error);
    }
  };

  //Query constructor
  //Query constructor
  //Query constructor
  const queryConstructorString = (type = searchType) => {
    let searchDatabaseType = "";

    // DRAFT & TRASH SHOULD IGNORE PAGECONTROL
    if (type === "Draft" || type === "Trash") {
      searchDatabaseType = `itemName[eq]=menue_tab&`;
    }

    // PUBLISHED ONLY
    else {
      // PARENT MENU
      if (pageControl === "parent") {
        searchDatabaseType = `itemName[eq]=menue_tab&item01[ne]=0&item02[eq]=0&item02b[eq]=0&`;
      }

      // CHILD MENU
      else if (pageControl === "child") {
        searchDatabaseType = `itemName[eq]=menue_tab&item01[eq]=${selectedParent}&item02[ne]=0&item02b[eq]=0&`;
      }

      // GRANDCHILD MENU
      else if (pageControl === "grandchild") {
        searchDatabaseType = `itemName[eq]=menue_tab&item01[eq]=${selectedParent}&item02[eq]=${selectedChild}&item02b[ne]=0&`;
      }
    }

    let query = `?${searchDatabaseType}`;
    let messages = "";

    const initializeSearchDate = {};

    // STATUS FILTERS
    if (type === "Published") {
      query += `status02[eq]=publish&`;
      messages += `PUBLISHED POSTS | `;
    }

    if (type === "Draft") {
      query += `status02[eq]=draft&`;
      messages += `DRAFT POSTS | `;
    }

    if (type === "Trash") {
      query += `status02[eq]=trash&`;
      messages += `TRASH POSTS | `;
    }

    const { input } = formData;

    // START DATE
    if (input.startDate) {
      query += `dater[gte]=${input.startDate}&`;
      messages += `START DATE: ${input.startDate} | `;
      initializeSearchDate.startDate = input.startDate;
    }

    // END DATE
    if (input.endDate) {
      query += `dater[lte]=${input.endDate}&`;
      messages += `END DATE: ${input.endDate} | `;
      initializeSearchDate.endDate = input.endDate;
    }

    // DEFAULT
    if (type !== "Published" && type !== "Draft" && type !== "Trash") {
      query += `status02[eq]=publish&`;
    }

    return { query, messages, initializeSearchDate };
  };

  // Fetch All Registry Records
  const fetchPagData = async (
    page = 1,
    customSearchType = searchType,
    customPerPage = perPage,
  ) => {
    const { query, messages, initializeSearchDate } =
      queryConstructorString(customSearchType);

    // Display Current Search Request Parameters as a Message
    setDisplayMessages(messages);

    // Store a sample of Current Search Request Parameters for Dialogue Box
    setDialogueState((prev) => ({
      ...prev,
      searchScript: query,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");
      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdata${query}&page=${page}&per_page=${customPerPage}`,
        ),
        axios.get(`${BASE_URL}pagquantity?itemName[eq]=menue_tab`),
      ]);

      const [PagData, populateNumbering] = responses;

      const records = PagData?.data?.allData || [];

      if (records.length === 0) {
        swal(
          "Oops!",
          "Sorry! we did not find any information in the Post",
          "warning",
        );
        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      } else {
        setDialogueState((prev) => ({
          ...prev,
          searchDates: initializeSearchDate,
        }));

        setAllRecords(records);
        setFilteredRecords(records);
        setPagination(
          PagData.data.pagination || {
            current_page: 1,
            last_page: 1,
            per_page: 10,
            total: 0,
          },
        );

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      populateNumbering.data.publish &&
        setPublishedRecords(populateNumbering.data.publish);
      populateNumbering.data.draft &&
        setDraftRecords(populateNumbering.data.draft);
      populateNumbering.data.trash &&
        setTrashRecords(populateNumbering.data.trash);
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.log("Error fetching Registry Data:", error);
    }
  };

  // Pagination
  const getPaginationRange = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;

    const delta = 1; // how many pages around current

    const range = [];
    const rangeStart = Math.max(2, current - delta);
    const rangeEnd = Math.min(total - 1, current + delta);

    range.push(1);

    if (rangeStart > 2) {
      range.push("...");
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }

    if (rangeEnd < total - 1) {
      range.push("...");
    }

    if (total > 1) {
      range.push(total);
    }

    return range;
  };

  const changePage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchPagData(page);
    }
  };

  const pages = getPaginationRange();

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchPagData();
  }

  const handleFilter = (event) => {
    const text = event.target.value.toLowerCase();

    const newData = filteredRecords.filter(
      (row) =>
        (row.item03 ?? "").toLowerCase().includes(text) ||
        (row.staff ?? "").toLowerCase().includes(text),
    );

    setAllRecords(newData.length > 0 ? newData : allRecords);
  };

  // Open Dialogue Box for Update
  async function updateData(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPag",
      modalTitle: "EDIT WEBPAGE",
      trigger: true,
      editpost: posts,
    }));
    setBtnColor("success");
  }

  // Open Dialogue Box for Draft
  async function draftData(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const draftItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}pagdata/draft/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Drafted", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once set to draft, you will have to  publish to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await draftItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Fresh Post
  async function addData() {
    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const initializeEditposts = {
      item01: "",
      item02: "",
      item02b: "",
      item03: "",
      item03b: "",
      position: "",
      linker: "",
      status02: "",
      dater: "",
    };

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPag",
      modalTitle: "POST WEBPAGE",
      trigger: true,
      editpost: initializeEditposts,
    }));
    setBtnColor("primary");
  }

  // Delete a Row of Data
  async function DeletePost(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const deleteItem = async () => {
      await axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}pagdata/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            formCleanner();
            swal("Trashed", res.data.message, "success");
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once trashed, you will not be able to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await deleteItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  // Open Dialogue Box for Printing Registry
  async function printPag() {
    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPagPrintout",
      modalTitle: "WEBPAGE DETAILS",
      trigger: true,
      editpost: allRecords,
    }));

    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchScript: null,
    }));

    fetchPagData();
  };

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  function softreload() {
    window.location.reload();
  }

  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        formCleanner={formCleanner}
        searchDate={dialogueState.searchDates}
        searchScript={dialogueState.searchScript}
        btnColor={btnColor}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <i className="fa fa-search"></i> SEARCH WEBPAGE
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div className="col-lg-12 row">
                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Published"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaRegNewspaper style={{ fontSize: "20px" }} />{" "}
                        Published ({publishedRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Draft"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12 border-end">
                        <FaBan style={{ fontSize: "20px" }} /> Draft (
                        {draftRecords})
                      </div>
                    </Link>

                    <Link
                      to=""
                      className="col-lg-2 pt-4"
                      onClick={searchDatabase}
                      data-value="Trash"
                      style={{ fontSize: "16px" }}
                    >
                      <div className="col-12">
                        <MdDelete style={{ fontSize: "20px" }} /> Trash (
                        {trashRecords})
                      </div>
                    </Link>

                    <div className="col-lg-2">
                      <Link
                        className="btn btn-success col-12 mt-4"
                        onClick={softreload}
                        to="/admin/pag"
                      >
                        <i className="fa fa-refresh"></i>
                      </Link>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-danger col-12 mt-4"
                        onClick={printPag}
                        data-toggle="modal"
                        data-target="#exampleModal"
                        disabled
                      >
                        <div className="d-flex justify-content-center">
                          <i className="fa fa-print pt-1 pe-2"></i>
                          Print Document
                        </div>
                      </button>
                    </div>

                    <div className="col-lg-2">
                      <button
                        className="btn btn-primary col-12 mt-4"
                        onClick={addData}
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-plus-square-o pt-1 pe-2"></i>
                          Add WEBPAGE
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-12 mt-4 row">
                    <InputField
                      label="Start Date"
                      name="startDate"
                      size="2"
                      placeholder="Please Select Start Date"
                      required=""
                      value={formData.input.startDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <InputField
                      label="End Date"
                      name="endDate"
                      size="2"
                      placeholder="Please Select End Date"
                      required=""
                      value={formData.input.endDate}
                      type="date"
                      onChange={updateFormData}
                      icon="fa fa-calendar-check-o"
                    />

                    <SelectField
                      label="Table Size"
                      name="tableSize"
                      size="2"
                      placeholder="Select a Table Size"
                      required="required"
                      value={perPage}
                      options={options.tableSize}
                      switchOptions={1}
                      type="text"
                      onChange={(type, key, value) => {
                        setPerPage(value);
                        fetchPagData(1, searchType, value);
                      }}
                      icon="fa fa-columns"
                    />

                    <div className="col-lg-2">
                      <button
                        className="btn btn-success col-12 mt-4"
                        onClick={searchData}
                      >
                        <div className=" d-flex justify-content-center">
                          <i className="fa fa-search pt-1 pe-2"></i>
                          {reloadState.btnLoading}
                        </div>
                      </button>
                    </div>

                    <div className="col-lg-2 mb-3">
                      {pageControl !== "parent" && (
                        <button
                          className="btn btn-secondary col-12 mt-4"
                          onClick={() => {
                            if (pageControl === "grandchild") {
                              setPageControl("child");
                            } else {
                              setPageControl("parent");
                            }
                          }}
                        >
                          ← Back
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> WebPage's
                Dashboard
                <span className="float-end me-3">{displayMessages}</span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="Search MenuPage or Staff."
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "5%" }}>
                            Select
                          </th>
                          {[
                            "Action",
                            "Tab Menu",
                            "Position",
                            "Drop Down",
                            "Visibility",
                            "Created By",
                          ].map((items, index) => (
                            <th key={index} scope="col">
                              {items}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allRecords.map((allRecord, index) => {
                          let activElement = "";
                          if (allRecord.item02b > 0) {
                            activElement = allRecord.item02b;
                          } else if (allRecord.item02 > 0) {
                            activElement = allRecord.item02;
                          } else if (allRecord.item01 > 0) {
                            activElement = allRecord.item01;
                          }
                          return (
                            <tr key={index}>
                              <th scope="row">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name={allRecord.id}
                                />
                              </th>
                              <td style={{ width: "20%" }}>
                                <button
                                  type="button"
                                  className="btn btn-success me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    updateData(event, allRecord)
                                  }
                                >
                                  <i className="fa fa-edit me-1"> </i>
                                  Edit
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    draftData(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-ban me-1"> </i>
                                  Draft
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(event) =>
                                    DeletePost(event, allRecord.id)
                                  }
                                >
                                  <i className="fa fa-trash me-1"> </i>
                                  Trash
                                </button>
                              </td>

                              <td style={{ width: "30%" }}>
                                {allRecord.item03}
                              </td>
                              <td style={{ width: "10%" }}>
                                {allRecord.position}
                              </td>
                              <td style={{ width: "10%" }}>
                                {subMenuCounts[activElement] ? (
                                  <Link
                                    to=""
                                    onClick={() =>
                                      searchControlDatabase(
                                        allRecord.item01,
                                        allRecord.item02,
                                        allRecord.item02b,
                                      )
                                    }
                                  >
                                    {subMenuCounts[activElement] +
                                      " Dropdown(s)"}
                                  </Link>
                                ) : (
                                  "..."
                                )}
                              </td>
                              <td style={{ width: "10%" }}>
                                {ucwords(allRecord.status02)}
                              </td>
                              <td style={{ width: "15%" }}>
                                {allRecord.staff}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <nav>
                    <ul className="pagination">
                      {/* Prev */}
                      <li
                        className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page - 1)
                          }
                        >
                          Prev
                        </button>
                      </li>

                      {/* Pages */}
                      {pages.map((page, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            page === pagination.current_page ? "active" : ""
                          } ${page === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => page !== "..." && changePage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page + 1)
                          }
                        >
                          Next
                        </button>
                      </li>

                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total: {pagination.total}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pag;
